import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import jsPDF from "jspdf";
import { addHeader, addFooter } from "common/PDFUtils/pdfUtils";
import { addSignature } from "common/PDFUtils/pdfUtils";
import { addTitle } from "common/PDFUtils/pdfUtils";
import { justifyText } from "common/PDFUtils/pdfUtils";


export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickNewManagement = () => {
        
        // navigate si funcionó
        navigate('/juridico-gestiones-form')
    }

    const handleClickInfoManagement = (idgestion, openingmode) => {
        
        // navigate si funcionó
        navigate(`/juridico-gestiones-form/${openingmode}/${idgestion}`)
    }

    const handleClickDeleteManagement = (idgestion) => {

        const { fetchAllManagements } = FetchData
        const { executeFetchAllManagements } = fetchAllManagements

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/vehicle/mgmt-managements/management/${idgestion}`)
                .then(({data}) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllManagements()
                    }
                    
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }

    const generatePDF = async(idcotizacion) => {

        const doc = new jsPDF();
        
        let y = 65
        let x = 20
        let texto

        const nombreCliente = "Juan Pérez";
        const dpi = "12345";

        //Agregamos los logos
        addHeader(doc)
        
        //Titulo
        addTitle(doc, y, 'FINIQUITO CRÉDITO DE VEHÍCULO')
        y+=20;
        
        // Cargar el archivo de texto
        try {
            const response = await fetch('/PDFText/FiniquitoVehiculo/finiquito.txt');
            if (!response.ok) {
                throw new Error('Error al cargar el archivo');
            }
            texto = await response.text();
        } catch (error) {
            console.error('Hubo un problema al cargar el archivo: ', error);
        }

        texto = texto
        .replace("{cliente}", nombreCliente)
        .replace("{dpi}", dpi)
        
        doc.setFont("times", "normal");
        doc.setFontSize(12);

        y = justifyText(doc, texto, 20, y, 170)

        // Firma (Dulce Pinto)
        addSignature(doc, y)

        // Pie de página
        addFooter(doc)
    
        // Guardar el PDF
        doc.save('finiquito_vehiculo.pdf');
    };



  

    return Object.freeze({
        handleClickNewManagement,
        handleClickInfoManagement,
        handleClickDeleteManagement,
        generatePDF
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}